import { FC } from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

const Link: FC<LinkProps> = ({ children, ...linkProps }) => {
  return <RouterLink {...linkProps}>{children}</RouterLink>;
};

export default Link;
